module.exports = __webpack_public_path__ + "static/media/movie.e589d147.png";